import React, { useEffect, useRef, useState } from 'react';
import {
  getByAccountTopN,
  getByChannelAccountCount,
} from '@/pages/opinion/services/accounts';
import { channelInfo } from '@/pages/opinion/components/ChannelLabel';
import { arrayToObj, scrollToAnchorPoint } from '@/pages/opinion/utils';
import ChartCard from '../../widgets/ChartCard';
import CommentsCard from '../../widgets/CommentsCard';
import { TabNavigator } from '@op/components/Navigator';
import { useIntl } from 'umi';
import BubbleCommon, { accountGuideTips } from '@op/components/BubbleCommon';
import { useStateRef } from '@op/hooks/common'; 

export default function OverviewTab({
  filter,
  type,
  gameInfo,
  navigators,
  setNavigators,
  defaultNavigator,
  baseNavigators,
  setSelectNavigator,
  selectNavigator,
  scrollBody,
  channelList,
}: any) {
  const [accountOrderBy, setAccountOrderBy] = useState('followers');
  const [topAccountLoading, setTopAccountLoading] = useState(false);
  const { formatMessage } = useIntl();
  // account 需要调用的接口
  const getTopAccounts = async () => {
    try {
      setTopAccountLoading(true);
      let { channel, social_media_by_account, ...otherParams } = filter;

      const accountsAccountTopCounts = await getByAccountTopN({
        ...otherParams,
        channels: channel,
        page: 1,
        page_size: 3,
        sort_model: 'desc',
        accounts: social_media_by_account,
        sort_item: accountOrderBy,
      });
      let { list, channel_account_split } = accountsAccountTopCounts || {};
      if (Array.isArray(list) && list?.length > 0) {
        let curNavigators = baseNavigators.slice(0, Math.min(list.length, 3));
        curNavigators = curNavigators.map(
          (item: { symbol: any }, index: number) => {
            let { account, channel, value, account_url } = list[index];
            const { name, img } = channelInfo(channel);
            // const realAccount = addSplitText(account, channel);

            const realAccount = social_media_by_account.find(
              (itemInfo: string) => {
                return (
                  itemInfo.includes(account?.toLocaleLowerCase()) &&
                  itemInfo.includes(channel)
                );
              },
            );

            return {
              // 获取渠道
              ...item,
              name: item.symbol,
              account: account,
              accounts: [realAccount],
              channel_accounts: [channel + channel_account_split + account],
              social_media_by_account: [realAccount],
              account_url,
              channels: [channel],
              channel: { name, img, channel_name: channel },
            };
          },
        );
        setNavigators(curNavigators);
      } else {
        setNavigators([]);
      }
    } catch {}
    setTopAccountLoading(false);
  };

  // channel 需要调用的接口
  const getChannelInfo = () => {
    let navigators: any = channelList.map((item: string) => ({
      symbol: item,
      noFormat: true,
    }));
    let keepParamsChannel = filter.channels;
    let accounts = [...filter.social_media_by_account].map((item) =>
      item?.toLocaleLowerCase(),
    );
    if (
      keepParamsChannel &&
      Array.isArray(keepParamsChannel) &&
      keepParamsChannel.length > 0
    ) {
      navigators = navigators.filter((item: { symbol: any }) =>
        keepParamsChannel.includes(item.symbol),
      );
    }
    getByChannelAccountCount({
      ...gameInfo,
      channels: navigators.map((item: { symbol: any }) => item.symbol),
      accounts,
    }).then((data: any) => {
      let channelMap: any = {};
      let list = data || [];
      channelMap = arrayToObj(list, 'channel');
      // console.log(accounts, 'List', filter);
      navigators = navigators.map((item: { symbol: any }) => {
        const { name, img } = channelInfo(item.symbol);
        let { List, total, channel } = channelMap[item.symbol] || {
          List: [],
          total: 0,
        };
        // 过滤掉用户未选中的
        List = List.map((item: string) => {
          const info = accounts.find((itemInfo: string) => {
            return (
              itemInfo.includes(item?.toLocaleLowerCase()) &&
              itemInfo.includes(channel)
            );
          });

          return info;
        }).filter(Boolean);

        if (List.length === 0) {
          // 如果没有官号数据，那么就使用undefined占位，以防止请求认为是获取所有官号
          List = ['undefined'];
        }
        return {
          ...item,
          name,
          symbol: item.symbol,
          social_media_by_account: List,
          accounts: List,
          total,
          channels: [item.symbol],
          channel: {
            name,
            img,
            channel_name: item.symbol,
          },
        };
      });
      setNavigators(navigators);
    });
  };

  useEffect(() => {
    if (!filter.edition_unified_id) return;
    if (type === 'channel') {
      getChannelInfo();
    } else {
      getTopAccounts();
    }
  }, [filter, accountOrderBy, type]);

  const [noDataMapRef, noDataMap, setNoDataMap] = useStateRef<{
    [key: string]: any;
  }>({});
  // const noDataMapRef = useRef<{ [key: string]: any }>({});

  /**
   * 获取导航选项的函数。
   *
   * 该函数返回一个导航选项数组，其中包含默认导航项和根据 navigators 数组生成的导航项。
   * 对于每个导航项，如果该项在 noDataMapRef.current 中存在或者该项的 total 为 0，则会显示相应的提示信息，并且该项将被禁用。
   *
   * @returns {Array} 导航选项数组
   */
  const getNavigatorOptions = () => {
    return [
      {
        label: formatMessage({ id: defaultNavigator }),
        id: defaultNavigator,
      },
      ...navigators.map((item: any) => {
        const flag = noDataMapRef.current[item.name] || item.total === 0;
        return {
          label: (
            <BubbleCommon
              showIcon={false}
              placement="top"
              tipsMap={flag ? accountGuideTips : null}
            >
              {type === 'account'
                ? formatMessage({ id: item.name })
                : item.name}
            </BubbleCommon>
          ),
          id: item.name,
          disabled: flag,
        };
      }),
    ];
  };

  return (
    <div className="dbo-accounts-overview">
      {navigators.length > 0 && (
        <TabNavigator
          scrollBody={scrollBody}
          options={getNavigatorOptions()}
          onChange={(curNavigator: any) => {
            setSelectNavigator(curNavigator);
            scrollToAnchorPoint(curNavigator, 'start');
          }}
          value={selectNavigator}
          setValue={setSelectNavigator}
        ></TabNavigator>
      )}
      {/* 图表部分 */}
      <section
        className="dbo-accounts-section"
        style={{ scrollMarginTop: 50 }}
        id={defaultNavigator}
      >
        <ChartCard type={type} keepParams={filter}></ChartCard>
      </section>

      <CommentsCard
        setAccountOrderBy={setAccountOrderBy}
        accountOrderBy={accountOrderBy}
        type={type}
        loading={false}
        navigators={navigators}
        keepParams={filter}
        setNoDataMap={(key: string, value: any) => {
          setNoDataMap({ ...noDataMapRef.current, [key]: value });
        }}
        noDataMap={noDataMapRef.current}
      ></CommentsCard>
    </div>
  );
}
